import actionTypes from './index';

export default shareStep => (dispatch) => {
  dispatch({
    type: actionTypes.SHARE_MODAL,
    step: shareStep,
  });
};
